var _rect, _rect2, _rect3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoftwareDevelopment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.583984,
    width: 75,
    height: 75,
    rx: 37.5,
    fill: "#65D3E9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.08398,
    y: 8.5,
    width: 59,
    height: 59,
    rx: 29.5,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.08398,
    y: 8.5,
    width: 59,
    height: 59,
    rx: 29.5,
    stroke: "#FAFAFA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2383_1070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2957 51.3831H43.9356C43.7782 51.3831 43.6497 51.2547 43.6497 51.0972V50.0359C43.6497 49.8786 43.5211 49.75 43.3638 49.75H37.2628C37.1054 49.75 36.9768 49.8786 36.9768 50.0359V51.0972C36.9768 51.2547 36.8482 51.3831 36.6908 51.3831H33.413C33.2556 51.3831 33.127 51.5117 33.127 51.669V52.8968C33.127 53.0541 33.2556 53.1827 33.413 53.1827H48.2955C48.4528 53.1827 48.5814 53.0541 48.5814 52.8968V51.669C48.5816 51.512 48.453 51.3831 48.2957 51.3831Z",
    fill: "#0B4F5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6204 22.6777H24.5077C23.4252 22.6777 22.5446 23.5585 22.5446 24.6411C22.5446 24.6411 22.5446 28.3849 22.5446 29.7621C22.5446 30.4392 22.4944 30.5349 22.9486 30.5349C23.1898 30.5349 23.4569 30.5349 23.7274 30.5349C24.1085 30.5349 24.0303 30.4392 24.0303 29.7495C24.0303 28.3754 24.0303 24.6411 24.0303 24.6411C24.0303 24.3824 24.2491 24.1637 24.5077 24.1637H55.6204C55.879 24.1637 56.0977 24.3824 56.0977 24.6411V43.809H33.9163C33.9163 43.809 33.1345 43.8076 33.1345 44.8185C33.1345 45.4178 33.1345 46.6166 33.1345 47.2161C33.1345 48.2256 33.9416 48.2256 33.9416 48.2256H55.6204C56.7028 48.2256 57.5837 47.3449 57.5837 46.2625V24.6411C57.5837 23.5586 56.703 22.6777 55.6204 22.6777ZM40.0642 46.5304C39.5754 46.5304 39.1793 46.1343 39.1793 45.6458C39.1793 45.1574 39.5754 44.7611 40.0642 44.7611C40.5525 44.7611 40.9486 45.1574 40.9486 45.6458C40.9486 46.1343 40.5525 46.5304 40.0642 46.5304Z",
    fill: "#0B4F5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1062 32.2891H18.851C18.1522 32.2891 17.584 32.8573 17.584 33.5562V52.0555C17.584 52.7542 18.1522 53.3227 18.851 53.3227H30.1062C30.8047 53.3227 31.3732 52.7542 31.3732 52.0555V33.5562C31.3732 32.8573 30.8047 32.2891 30.1062 32.2891ZM23.0902 33.5814H25.8669C25.9993 33.5814 26.107 33.6887 26.107 33.8216C26.107 33.9542 25.9994 34.0616 25.8669 34.0616H23.0902C22.9576 34.0616 22.8502 33.9542 22.8502 33.8216C22.8502 33.6887 22.9576 33.5814 23.0902 33.5814ZM24.4618 52.4327C24.0996 52.4327 23.806 52.1391 23.806 51.777C23.806 51.4148 24.0996 51.1212 24.4618 51.1212C24.8239 51.1212 25.1175 51.4148 25.1175 51.777C25.1175 52.1391 24.8239 52.4327 24.4618 52.4327ZM30.2846 50.5054C30.2846 50.6745 30.1492 50.8128 29.984 50.8128H18.9736C18.8082 50.8128 18.6729 50.6745 18.6729 50.5054V35.1332C18.6729 34.9641 18.8083 34.8259 18.9736 34.8259H29.984C30.1493 34.8259 30.2846 34.9642 30.2846 35.1332V50.5054Z",
    fill: "#0B4F5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2383_1070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(17.584 18)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareDevelopment);
export default __webpack_public_path__ + "static/media/software-development.baa6bfeae2ac799fabc637baa47f077a.svg";
export { ForwardRef as ReactComponent };